__turbopack_context__.v({
  "basket": "P48_Aa_basket",
  "basketBox": "P48_Aa_basketBox",
  "basketContent": "P48_Aa_basketContent",
  "basketEmpty": "P48_Aa_basketEmpty",
  "basketIcon": "P48_Aa_basketIcon",
  "bolleke": "P48_Aa_bolleke",
  "cartAndHamburger": "P48_Aa_cartAndHamburger",
  "choice": "P48_Aa_choice",
  "choiceError": "P48_Aa_choiceError",
  "closeBasket": "P48_Aa_closeBasket",
  "hamburger": "P48_Aa_hamburger",
  "homeButton": "P48_Aa_homeButton",
  "icon": "P48_Aa_icon",
  "languageAndCart": "P48_Aa_languageAndCart",
  "languageFR": "P48_Aa_languageFR",
  "languageNL": "P48_Aa_languageNL",
  "line": "P48_Aa_line",
  "links": "P48_Aa_links",
  "menu": "P48_Aa_menu",
  "menuOpen": "P48_Aa_menuOpen",
  "nav": "P48_Aa_nav",
  "open": "P48_Aa_open",
  "recap": "P48_Aa_recap",
  "redirects": "P48_Aa_redirects",
  "shoppingCart": "P48_Aa_shoppingCart",
});
